import { render, staticRenderFns } from "./FichaDesenvolvimentoAnual.vue?vue&type=template&id=9d21b380"
import script from "./FichaDesenvolvimentoAnual.vue?vue&type=script&lang=js"
export * from "./FichaDesenvolvimentoAnual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports